import { Component, OnInit, OnDestroy, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { AlertService } from '../../../../core/services/alert.service';
import { PopupAlert, PopupAlertType } from '../../../../core/models/alert.model';
import { ASSETS } from '@app/core/constants/assets.constants';

@Component({
  selector: 'app-popup-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './popup-alert.html',
  styleUrl: './popup-alert.scss'
})
export class PopupAlertComponent implements OnInit, OnDestroy {
  popupAlerts: PopupAlert[] = [];
  private subscription: Subscription = new Subscription();
  IMAGES = ASSETS;

  constructor(@Inject(AlertService) private alertService: AlertService) {}

  ngOnInit(): void {
    this.subscription = this.alertService.popupAlerts$.subscribe((alerts: PopupAlert[]) => {
      this.popupAlerts = alerts;
    });
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  closePopup(alertId: string): void {
    this.alertService.removePopupAlert(alertId);
  }

  executeAction(action: () => void): void {
    action();
  }

  getPopupClass(alert: PopupAlert): string {
    return `popup-alert popup-${alert.type}`;
  }

  getIconClass(alert: PopupAlert): string {
    return alert.type === PopupAlertType.SUCCESS ? 'success-icon' : 'error-icon';
  }
}
